
import React from 'react';
import { FormHelperText } from '@mui/material';
import { LoaderMini } from '~/components/Loaders';
import history from '~/services/history';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import EsteiraComponent from './EsteiraComponent';

/* eslint-disable */


function Primeiro(props) {
	const {documento, setDocumento, errorMessage, setErrorMessage, step, verifyDocument, loading} = props;


	function getBackPage() {
		history.push('login');
	}

	function applyMask(value) {
		value = value.replace(/\D/g, '');

		if(value.length <= 11){
			if (value.length === 11) {
				validarCpf(value)
			}
			return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
		}

		validarCnpj(value)
		return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
	}

	function validarCpf(cpf) {
		cpf = cpf.replace(/\D/g, '');

		if (cpf.length !== 11) {
			setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
		  	return false;
		}

		if (/^(\d)\1{10}$/.test(cpf)) {
			setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
		  	return false;
		}

		let soma = 0;
		let resto;

		for (let i = 0; i < 9; i++) {
		  soma += parseInt(cpf.charAt(i), 10) * (10 - i);
		}
		resto = (soma * 10) % 11;
		if (resto === 10 || resto === 11) {
		  resto = 0;
		}
		if (resto !== parseInt(cpf.charAt(9), 10)) {
			setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
		  	return false;
		}

		soma = 0;
		for (let i = 0; i < 10; i++) {
		  soma += parseInt(cpf.charAt(i), 10) * (11 - i);
		}
		resto = (soma * 10) % 11;
		if (resto === 10 || resto === 11) {
		  resto = 0;
		}
		if (resto !== parseInt(cpf.charAt(10), 10)) {
			setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
		  	return false;
		}

		setErrorMessage('')
		return true;
	  }

	function validarCnpj(cnpj) {
		cnpj = cnpj.replace(/\D/g, '');
		if (cnpj.length !== 14) {
			setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
			return false;
		}
		let soma = 0;
		const peso = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

		for (let i = 0; i < 12; i++) {
			soma += parseInt(cnpj.charAt(i), 10) * peso[i + 1];
		}
		let resto = soma % 11;
		if (resto < 2) {
			if (parseInt(cnpj.charAt(12), 10) !== 0) {
				setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
				return false;
			}
		} else {
			if (parseInt(cnpj.charAt(12), 10) !== 11 - resto) {
				setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
				return false;
			}
		}

		soma = 0;
		for (let i = 0; i < 13; i++) {
			soma += parseInt(cnpj.charAt(i), 10) * peso[i];
		}
		resto = soma % 11;
		if (resto < 2) {
			if (parseInt(cnpj.charAt(13), 10) !== 0) {
				setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
				return false;
			}
		} else {
			if (parseInt(cnpj.charAt(13), 10) !== 11 - resto) {
				setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
				return false;
			}
		}
		setErrorMessage('')
		return true;
	}

	return (
		<div className="w-100">
			<FormGroup>
				<Label>Digite o seu CPF/CNPJ</Label>
				<Input
					id="documento-token"
					placeholder="Somente números"
					style={{borderColor:errorMessage ? 'red' : 'gray'}}
					value={documento}
					onChange={(elemento) => {
							setErrorMessage('')
							const newValue = applyMask(elemento.target.value)
							setDocumento(newValue)
						}
					}
				/>
				{errorMessage && (
					<FormHelperText>
						<i style={{ color: "red"}}>{errorMessage}</i>
					</FormHelperText>
				)}

			</FormGroup>


			<EsteiraComponent step={step} />

			<Row className="rowButton">
				<Col>
					<Button
						outline
						color="primary"
						className="buttonComponentOutline px-5"
						onClick={() => getBackPage()}>
						VOLTAR
					</Button>
				</Col>
				<Col>
					<Button
						color="primary"
						className="buttonComponent px-5"
						disabled={(documento.replace(/\D/g, '').length !== 11 && documento.replace(/\D/g, '').length !== 14) || errorMessage.length > 0 || loading}
						onClick={() => {
							verifyDocument()
							}}>

						{!loading ? 'ENVIAR' : <LoaderMini width="20" /> }

					</Button>
				</Col>
			</Row>
		</div>
	);
}

export default Primeiro;
